import { render, staticRenderFns } from "./ImageModal.vue?vue&type=template&id=1611e641"
import script from "./ImageModal.vue?vue&type=script&lang=js"
export * from "./ImageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1611e641')) {
      api.createRecord('1611e641', component.options)
    } else {
      api.reload('1611e641', component.options)
    }
    module.hot.accept("./ImageModal.vue?vue&type=template&id=1611e641", function () {
      api.rerender('1611e641', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BulmaModal/ImageModal.vue"
export default component.exports